export default "__VITE_ASSET__DvYWFSdk__"